module.exports = __webpack_public_path__ + "5534076422bd6cb622b838dc59196d30.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/star-bg.svg
 ** module id = 1545
 ** module chunks = 0
 **/